module.exports = __webpack_public_path__ + "media/images/area/maps/Path 2-2e1e58f89c4ff2f7b1478cac2ff5c663.svg";